export default __webpack_public_path__ + "static/1-1735f2788370f360bf489422e23c95d5.png";